import React from 'react';
import { StyledCustomArrow, ArrowIcon } from './CarouselArrows.styles';

const CarouselArrows = ({ carouselId, presentation, cardType }) => (
    <div>
        <StyledCustomArrow
            type="button"
            aria-label="Gå bakåt i lista"
            htmlFor={`core-carousel-${carouselId}`}
            value="left"
            direction="LEFT"
            presentation={presentation}
            cardType={cardType}
            disabled={true}
            tabIndex={-1}
        >
            <ArrowIcon className="svt_icon svt_icon--angle-left" />
        </StyledCustomArrow>

        <StyledCustomArrow
            type="button"
            aria-label="Gå framåt i lista"
            htmlFor={`core-carousel-${carouselId}`}
            value="right"
            direction="RIGHT"
            presentation={presentation}
            cardType={cardType}
            tabIndex={-1}
        >
            <ArrowIcon className="svt_icon svt_icon--angle-right" />
        </StyledCustomArrow>
    </div>
);

export default CarouselArrows;
